<template>
  <div class="open-bets">
    <div class="open-bets-dropdown-wrapper">
      <div @click="showDropdown"
           v-click-outside:shouldShowDropdown="showDropdown.bind(showDropdown,'shouldShowDropdown')"
           class="open-bets-dropdown">
        <div class="open-bets-dropdown-selection">
          <div class="open-bets-dropdown-text">
            <span>{{$t(`bets.openBets.filters.${selectedFilter}`)}}</span>
          </div>
        </div>
        <div
          v-bind:class="{'open-bets-dropdown-dropdown-arrow-open':dropdowns.shouldShowDropdown}"
          class="open-bets-dropdown-dropdown-arrow">
          <v-icon>
            krypt-arrow-down
          </v-icon>
        </div>
      </div>
      <div class="open-bets-dropdown-anchor">
        <div v-bind:class="{'open-bets-dropdown-absolute-open':dropdowns.shouldShowDropdown}"
             class="open-bets-dropdown-absolute">
          <div v-bind:class="{'open-bets-dropdown-contents-open':dropdowns.shouldShowDropdown}"
               class="open-bets-dropdown-contents">

            <div
              class="open-bets-dropdown-item"
              @click="changeFilter('all')"
            >
              <div class="open-bets-dropdown-item-selection">
                <div class="open-bets-dropdown-item-text">
                  <span>{{$t('bets.openBets.filters.all')}}</span>
                </div>
              </div>
            </div>
            <div
              class="open-bets-dropdown-item"
              @click="changeFilter('unmatched')"
            >
              <div class="open-bets-dropdown-item-selection">
                <div class="open-bets-dropdown-item-text">
                  <span>{{$t('bets.openBets.filters.unmatched')}}</span>
                </div>
              </div>
            </div>
            <div
              class="open-bets-dropdown-item" v-if="selectedEvent !=='none'"
              @click="changeFilter('selectedEventAll')"
            >
              <div class="open-bets-dropdown-item-selection">
                <div class="open-bets-dropdown-item-text">
                  <span>{{$t('bets.openBets.filters.selectedEventAll')}}</span>
                </div>
              </div>
            </div>
            <div
              class="open-bets-dropdown-item" v-if="selectedEvent !=='none'"
              @click="changeFilter('selectedEventUnmatched')"
            >
              <div class="open-bets-dropdown-item-selection">
                <div class="open-bets-dropdown-item-text">
                  <span>{{$t('bets.openBets.filters.selectedEventUnmatched')}}</span>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    <div class="empty-open-bets" v-if="betsGroupedByEventAndType.length === 0">
      <div class="empty-open-bets-image">
        <v-icon>krypt-betslip</v-icon>
      </div>
      <div class="empty-open-bets-text" v-if="selectedFilter !=='all'">
        <span>{{$t(`bets.openBets.noBetsFound`)}}</span>
      </div>
      <div class="empty-open-bets-text" v-if="selectedFilter ==='all'">
        <span>{{$t(`bets.openBets.noOpenBets`)}}</span>
      </div>
    </div>

    <div v-if="betsGroupedByEventAndType.length !== 0" class="open-bets-container">
      <template v-for="event in betsGroupedByEventAndType">
        <!--       <div>{{event.timeStamp}}</div>-->
        <div class="open-bets-container-back" v-if="event.bets.back.length > 0">
          <div class="open-bets-container-header" v-if="event.eventName">
            <span>{{event.eventName}}</span>
          </div>
          <div class="open-bets-container-header" v-if="typeof event.eventName ==='undefined'">
            <span>{{event.homeTeam}} &ndash; {{event.awayTeam}}</span>
          </div>
          <div class="open-bets-container-content">
            <OpenBetCard v-for="(backBet,betPosition) in event.bets.back" v-bind:key="backBet.id"
                         :betPosition="betPosition"
                         :betData="backBet" :type="'back'"></OpenBetCard>
          </div>
        </div>
        <div class="open-bets-container-lay" v-if="event.bets.lay.length > 0">
          <div class="open-bets-container-header" v-if="event.eventName">
            <span>{{event.eventName}}</span>
          </div>
          <div class="open-bets-container-header" v-if="typeof event.eventName ==='undefined'">
            <span>{{event.homeTeam}} &ndash; {{event.awayTeam}}</span>
          </div>
          <div class="open-bets-container-content">
            <OpenBetCard v-for="(layBet,betPosition) in event.bets.lay" v-bind:key="layBet.id"
                         :betPosition="betPosition"
                         :betData="layBet" :type="'lay'"></OpenBetCard>
          </div>
        </div>
      </template>

    </div>

  </div>
</template>

<script>
import OpenBetCard from '@/components/other/openBetCard';

export default {
  name: 'OpenBets',
  components: {
    OpenBetCard,
  },
  data: function () {
    return {
      dropdowns:{
        shouldShowDropdown: false
      },
      OpenBetFilters: [
        'All Bets',
        'Unmatched',
        'Selected Event - All Bets',
        'Selected Event - Unmatched'
      ],
      _clickOutside:{
        dropdown:null
      }
      // selectedFilter: 0
    };
  },
  computed: {

    betsGroupedByEventAndType: function () {
      return Object.values(JSON.parse(JSON.stringify(this.$store.state.bets.active.openBets)))
        .sort(function (a, b) {
          if (a.timeStamp < b.timeStamp) {
            return 1;
          }
          if (a.timeStamp > b.timeStamp) {
            return -1;
          }
          return 0;
        })
        .map(function (eventGroup) {
          let filteredEventGroup = eventGroup;
          filteredEventGroup.bets.lay = filteredEventGroup.bets.lay.filter(function (bet) {
            if (this.selectedFilter === 'selectedEventAll') {
              if (this.selectedEvent.id === bet.eventId) {
                return true;
              } else {
                return false;
              }
            } else if (this.selectedFilter === 'unmatched') {
              if (bet.betStatus === 'Unmatched') {
                return true;
              } else {
                return false;
              }
            } else if (this.selectedFilter === 'selectedEventUnmatched') {
              if (this.selectedEvent.id === bet.eventId && bet.betStatus === 'Unmatched') {
                return true;
              } else {
                return false;
              }

            } else {
              return true;
            }
          }.bind(this));
          filteredEventGroup.bets.back = filteredEventGroup.bets.back.filter(function (bet) {
            if (this.selectedFilter === 'selectedEventAll') {
              if (this.selectedEvent.id === bet.eventId) {
                return true;
              } else {
                return false;
              }

            } else if (this.selectedFilter === 'unmatched') {
              if (bet.betStatus === 'Unmatched') {
                return true;
              } else {
                return false;
              }
            } else if (this.selectedFilter === 'selectedEventUnmatched') {
              if (this.selectedEvent.id === bet.eventId && bet.betStatus === 'Unmatched') {
                return true;
              } else {
                return false;
              }

            } else {
              return true;
            }
          }.bind(this));

          return filteredEventGroup;
        }.bind(this)).filter((group)=>{return group.bets.back.length > 0 ||  group.bets.lay.length > 0});
    },
    selectedFilter: function () {
      return this.$store.state.bets.active.selectedFilter;
    },
    selectedEvent: function () {
      return this.$store.state.navigations.selectedEvent;
    },
    selectedEventId: function () {
      return this.selectedEvent.id;
    }
  },
  watch: {
    selectedEventId: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (Object.values(JSON.parse(JSON.stringify(this.$store.state.bets.active.openBets)))
          .filter(function (group) {
            let isValidGroup = true;
            if(newValue && (group.eventId !== newValue)){
              isValidGroup = false
            }
            if(group.bets.lay.filter(function (bet) {
                if (bet.betStatus === 'Unmatched') {
                  return true;
                } else {
                  return false;
                }

            }.bind(this)).length === 0 &&
              group.bets.back.filter(function (bet) {
                if (bet.betStatus === 'Unmatched') {
                  return true;
                } else {
                  return false;
                }
              }.bind(this)).length === 0){
              isValidGroup = false

            }
            return isValidGroup
          }.bind(this)).length > 0) {
          if (typeof newValue !== 'undefined') {
            this.$store.commit('setSelectedOpenBetFilter', 'selectedEventUnmatched');
          } else {
            this.$store.commit('setSelectedOpenBetFilter', 'unmatched');
          }
        } else {
          if (typeof newValue !== 'undefined') {
            this.$store.commit('setSelectedOpenBetFilter', 'selectedEventAll');
          } else {
            this.$store.commit('setSelectedOpenBetFilter', 'all');
          }
        }
      }
      ;
    }
  },
  methods: {
    showDropdown: function () {
      this.dropdowns.shouldShowDropdown = !this.dropdowns.shouldShowDropdown;
    },
    changeFilter: function (selectedFilter) {
      // this.selectedFilter = selected;
      this.$store.commit('setSelectedOpenBetFilter', selectedFilter);
      this.showDropdown();
    }
  },
  mounted() {
    if (Object.values(JSON.parse(JSON.stringify(this.$store.state.bets.active.openBets)))
      .filter(function (group) {
        let isValidGroup = true;
        if(this.selectedEventId && (group.eventId !== this.selectedEventId)){
          isValidGroup = false
        }
        if(group.bets.lay.filter(function (bet) {
            if (bet.betStatus === 'Unmatched') {
              return true;
            } else {
              return false;
            }

          }.bind(this)).length === 0 &&
          group.bets.back.filter(function (bet) {
            if (bet.betStatus === 'Unmatched') {
              return true;
            } else {
              return false;
            }
          }.bind(this)).length === 0){
          isValidGroup = false

        }
        return isValidGroup
      }.bind(this)).length > 0) {
      if (typeof this.selectedEventId !== 'undefined') {
        this.$store.commit('setSelectedOpenBetFilter', 'selectedEventUnmatched');
      } else {
        this.$store.commit('setSelectedOpenBetFilter', 'unmatched');
      }
    } else {
      if (typeof this.selectedEventId !== 'undefined') {
        this.$store.commit('setSelectedOpenBetFilter', 'selectedEventAll');
      } else {
        this.$store.commit('setSelectedOpenBetFilter', 'all');
      }
    }

  },
  directives: {
    clickOutside: {
      componentUpdated: function (el, binding, vnode) {
        setTimeout(() => {
          const handler = (e) => {
            if (!el.contains(e.target) && el !== e.target && vnode.context.$data.dropdowns[binding.arg]) {
              binding.value(e);
            }
          };
          if (vnode.context.$data.dropdowns[binding.arg]) {
            if (vnode.context.$data._clickOutside[binding.arg] == null) {
              vnode.context.$data._clickOutside[binding.arg] = handler;
              document.addEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            }
          } else {
            document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
            vnode.context.$data._clickOutside[binding.arg] = null;
          }
        }, 100);
      },
      unbind: function (el, binding, vnode) {
        document.removeEventListener('click', vnode.context.$data._clickOutside[binding.arg]);
        vnode.context.$data._clickOutside[binding.arg] = null;
      }
    }
  }

};
</script>

<style scoped>

  .open-bets {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .open-bets-dropdown-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px;
    flex-direction: column;
  }

  .open-bets-dropdown {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--grey-300);
    border-radius: 4px;
    width: 100%;
    cursor: pointer;
    background-color: white;
  }

  .open-bets-dropdown-text {
    display: flex;
    padding: 8px;
    user-select: none;
    overflow: hidden;
  }

  .open-bets-dropdown-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .open-bets-dropdown-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 28px);
  }

  .open-bets-dropdown-dropdown-arrow, .open-bets-dropdown-dropdown-arrow > i {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
  }

  .open-bets-dropdown-dropdown-arrow {
    margin-right: 4px;
    margin-left: 8px;
  }

  .open-bets-dropdown-dropdown-arrow > i {
    font-size: 16px;
    color: var(--grey-900);
  }

  .open-bets-dropdown-dropdown-arrow-open > i {
    transform: rotateZ(-180deg);
  }

  .open-bets-dropdown-anchor {
    position: relative;
    width: 100%;
  }

  .open-bets-dropdown-absolute {
    position: absolute;
    width: 100%;
    z-index: 10;
    top: 4px;
    transition: padding-top 0s 0.4s;
    background: white;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19);
  }

  .open-bets-dropdown-absolute-open {
    top: 4px;
    border-radius: 4px;
    overflow: hidden;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 2px;
    transition: padding-top 0s;
  }

  .open-bets-dropdown-contents::-webkit-scrollbar {
    width: 8px;
    background: #f0f0f0;
    /* disabling to make it look like on Firefox
    border-radius: 4px;
    margin-bottom: 4px; */
  }

  .open-bets-dropdown-contents::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .open-bets-dropdown-contents::-webkit-scrollbar-thumb:hover {
    background: #a6a6a6;
    /* disabling to make it look like on Firefox
    border-radius: 4px; */
  }

  .open-bets-dropdown-contents {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    max-height: 0;
    width: 100%;
    overflow: hidden;
    flex-direction: column;
    transition: max-height 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);
    /* border-radius: 4px; */
    /*border: white 1px solid;*/
    background: white;
    scrollbar-width: thin;
  }


  .open-bets-dropdown-contents-open {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    max-height: 200px;
  }

  /* not need - it's inside another container
  .open-bets-dropdown-contents:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .open-bets-dropdown-contents:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  } */

  .open-bets-dropdown-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    transition: background-color 0.25s ease-in-out;
  }

  .open-bets-dropdown-item:hover {
    background: var(--grey-200);
    cursor: pointer;
  }

  .open-bets-dropdown-item-selection {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .open-bets-dropdown-item-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    margin: 0 4px;
  }

  .open-bets-dropdown-item-text {
    display: flex;
    padding: 8px;
    user-select: none;
  }

  .open-bets-dropdown-item-text > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: var(--grey-800);
  }

  .empty-open-bets {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }

  .empty-open-bets-image {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
  }

  .empty-open-bets-image > .v-icon {
    display: flex;
    align-items: center;
    max-width: 122px;
    max-height: 122px;
    font-size: 122px;
    color: var(--grey-300);
  }

  .empty-open-bets-text {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }

  .empty-open-bets-text > span {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
  }

  .open-bets-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 8px 8px 8px;
  }

  #bets-container {
    overscroll-behavior: contain;
  }

  .open-bets-container-back, .open-bets-container-lay {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.19) !important;
    margin-bottom: 8px;
    border-radius: 6px;
  }

  .open-bets-container-back > .open-bets-container-header {
    background-color: var(--superman);
  }

  .open-bets-container-lay > .open-bets-container-header {
    background-color: var(--lex-luthor);
  }

  .open-bets-container-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: 6px 6px 0px 0px;
  }

  .open-bets-container-header > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #FFFFFF;
    padding: 8px;
  }

  .open-bets-container-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* border-bottom: 1px solid var(--grey-300); */
  }

  .open-bets-container-content > .bet-card-container:not(:last-child) {
    border-bottom: solid 1px var(--grey-300);
  }

  .bet-card-container:not(:last-child) >>> .bet-alert.success-message {
    border-radius: 0 0 6px 6px;
  }

</style>
